import { Outlet } from "react-router-dom";
import ResponsiveAppBar from "../components/app-bar/AppBar";
function LayoutDashboard(_props) {
  return (
    <>
      <ResponsiveAppBar />
      <div className="bg-bg px-8 py-14 min-h-[calc(100vh-4.5rem)]">
        <Outlet />
      </div>
    </>
  );
}

export default LayoutDashboard;
